import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { Box } from '@chakra-ui/react';
import Sidebar from './components/Sidebar';
import Header from './components/Header';
import Dashboard from './pages/Dashboard';
import Products from './pages/Products';
import Customers from './pages/Customers';
import Suppliers from './pages/Suppliers';
import Categories from './pages/Categories'
import Login from './pages/Login';
import SellInvoicesPage from './pages/SellInvoicesPage';
import ArrivalInvoicesPage from './pages/ArrivalInvoicesPage';
import ReturnInvoicesPage from './pages/ReturnInvoicesPage';
import ProductCardPrinter from './pages/ProductCardPrinter';

// Component to protect routes
const PrivateRoute = ({ children }) => {
  const token = localStorage.getItem('access');
  return token ? children : <Navigate to="/login" />;
};

// Main Layout Component
const MainLayout = ({ isSidebarExpanded, setIsSidebarExpanded }) => {
  const location = useLocation();
  const showSidebar = location.pathname !== '/login';

  return (
    <>
      <Header />
      {showSidebar && (
        <Sidebar isExpanded={isSidebarExpanded} setIsExpanded={setIsSidebarExpanded} />
      )}
      <Box
        ml={showSidebar ? (isSidebarExpanded ? "150px" : "30px") : "0"} // Adjust for sidebar visibility
        pt="60px"
        p="20"
      >
        <Routes>
          <Route path="/" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
          <Route path="/categories" element={<PrivateRoute><Categories /></PrivateRoute>} />
          <Route path="/products" element={<PrivateRoute><Products /></PrivateRoute>} />
          <Route path="/customers" element={<PrivateRoute><Customers /></PrivateRoute>} />
          <Route path="/suppliers" element={<PrivateRoute><Suppliers /></PrivateRoute>} />
          <Route path="/sell-invoices" element={<PrivateRoute><SellInvoicesPage /></PrivateRoute>} />
          <Route path="/arrival-invoices" element={<PrivateRoute><ArrivalInvoicesPage /></PrivateRoute>} />
          <Route path="/return-invoices" element={<PrivateRoute><ReturnInvoicesPage /></PrivateRoute>} />
          <Route path="/print-product-cards" element={<PrivateRoute><ProductCardPrinter /></PrivateRoute>} />
        </Routes>
      </Box>
    </>
  );
};

const App = () => {
  const [isSidebarExpanded, setIsSidebarExpanded] = useState(true);

  return (
    <Router>
      <Routes>
        {/* Public Route */}
        <Route path="/login" element={<Login />} />

        {/* Private Route Layout */}
        <Route
          path="/*"
          element={<MainLayout isSidebarExpanded={isSidebarExpanded} setIsSidebarExpanded={setIsSidebarExpanded} />}
        />
      </Routes>
    </Router>
  );
};

export default App;
